skrilla.service('searchService', function($http, $q, envService, modalService, $location, $window, cacheService){

    var apiUrl = envService.read('apiUrl');
    var unauthorisedRequests = [];

    var get = function(path, errorMessage, loadingSpinner){
        return showLoadingSpinner(loadingSpinner).then(function(){
            return $http.get(apiUrl + path).then(function(response){return successCallback(response)}, function(response){
                var replay = {
                    type: "get",
                    arguments: [path]
                }
                return errorCallback(response, errorMessage, replay)
            });
        });
    }

    var put = function(path, data, successMessage, loadingSpinner) {
        return showLoadingSpinner(loadingSpinner).then(function(){
            return $http.put(apiUrl + path, data).then(function(response){return successCallback(response, successMessage)}, function(response){
                var replay = {
                    type: "put",
                    arguments: [path, data, successMessage]
                }
                return errorCallback(response, true, replay)
            });
        });
    }

    var post = function(path, data, successMessage, loadingSpinner) {
        return showLoadingSpinner(loadingSpinner).then(function(){
            return $http.post(apiUrl + path, data).then(function(response){return successCallback(response, successMessage)}, function(response){
                var replay = {
                    type: "post",
                    arguments: [path, data, successMessage]
                }
                return errorCallback(response, true, replay)
            });
        });
    }

    var deleteRequest = function(path, successMessage, loadingSpinner){
        return showLoadingSpinner(loadingSpinner).then(function(){
            console.log(apiUrl + path);
            return $http.delete(apiUrl + path).then(function(response){return successCallback(response, successMessage)}, function(response){
                var replay = {
                    type: "deleteRequest",
                    arguments: [path, successMessage]
                }
                return errorCallback(response, true, replay)
            });
        });
    }


    function login(data, success, error){
        $http.post(envService.read('loginUrl'), data).then(function(response){
            //successCallback(response, successMessage, true)
            success(response);
            var requests = [];
            unauthorisedRequests.forEach(function(request){requests.push(request)});
            requests.forEach(function(request){
                fns[request.type].apply(this, request.arguments).then(function(response){
                    request.defer.resolve(response);
                }, function(response){
                    request.defer.reject(response)
                });
            });
            unauthorisedRequests = [];
        }, function(response){
            console.log(response);
            if(response.status === 403){
                if(response.data.errors && response.data.errors.length > 0){
                    response.data.errors.forEach(function(error){
                        if(error.messageTemplate === "password.reset.required"){
                            swal("Error!", "Password reset required", "error");
                        }
                        else{
                            swal("Error!", error.message, "error");
                        }
                    });
                }
                else{
                    swal("Error!", error.data.message)
                }
            }
            else if(response.status === 401) {
                swal("Error!", "Invalid login details!", "error");
            }
            //return $q.reject(response);
            error(response);
        });
    }

    function logout(){
        $http.post(envService.read('loginUrl')  + "revoke-all-sessions", {});
    }

    var getUsers = function(queryString, callback){
        return get('users' + queryString, false, true).then(function(response){
            callback(response);
            return response;
        });
    }

    function extendSession(){
        $http.get(envService.read('loginUrl') + "refresh-session");
    }

    function successCallback(response, successMessage, dontExtend){
        modalService.closeLoadingModal()
        if(successMessage) {
            swal("Success!", successMessage, "success");
        }
        if(dontExtend !== true) {
            //extendSession();
        }
        console.log(response);
        return response;
    }

    function showLoadingSpinner(loadingSpinner){
        var deferred = $q.defer();
        if(loadingSpinner) {
            //On refresh this wasn't working without a timeout
            setTimeout(function(){
                modalService.openLoadingModal();
                deferred.resolve(true);
            }, 100)
        }
        else{
            deferred.resolve(true);
        }
        return deferred.promise;
    }

    function errorCallback(response, errorMessage, replay){
        modalService.closeLoadingModal()
        var deferred = $q.defer();
        if (response.status === 401) {
            if($location.path() != "/login" && $location.path() != "/changePassword") {
                //location.href = "/#/login?returnUrl=" + $location.path();
                //modalService.openModal("views/login/loginModal.html", true, "lg", false, false);
                modalService.loginModal();
                $window.localStorage.token = null;
                replay.defer = deferred;
                unauthorisedRequests.push(replay);
            }
        }
        else if(errorMessage){
            if(typeof errorMessage !== 'string' || !errorMessage instanceof String){
                errorMessage = errorMessages(response.data)
            }
            cacheService.registerObject("errorResponse", {data:response, message: errorMessage});
            modalService.openModal("views/errorModal/errorModal.html", true, 'lg', true, true);
            deferred.reject();
        }
        else if(response.status == 404){
            swal("Error!", "404 Content Not Found", "error");
            deferred.reject();
        }
        else if(response.status == 500){
            swal("Error!", "Server Error", "error");
            deferred.reject();
        }
        console.log(response);
        return deferred.promise;
    }

    function errorMessages(data) {
        if (data && data.displayText) {
            return data.displayText
        }
        if (data && data.errors && data.errors.length > 0) {
           return data.errors.map((it) => (it.propertyPath ? it.propertyPath + ": " : "") + (it.developerMessage || it.message) ) .join("\n")
        }
        return "Unable to complete task!"
    }

    var fns = {
        get: get,
        put: put,
        post: post,
        deleteRequest: deleteRequest,
        getUsers: getUsers,
        login: login,
        logout: logout
    };

    return fns;
});

